export const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
export const passwordRegex =
  /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;
export const telephoneRegex = /^\d{10}$/;
export const nameRegex = /^[a-zA-ZÀ-ÿ\u00f1\u00d1\s]+$/;
